import React, { useCallback } from 'react';

import { Backdrop, Modal, Fade } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { closeGifModalAction } from 'actions/gifModal';
import Gif from 'components/Gif';
import FocusLock from 'react-focus-lock';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { CenterFlexCSS } from 'styles/common';

const useStyles = makeStyles({
  // to override chakra ui modal zIndex
  root: {
    zIndex: '1401 !important',
  },
});

export default function GifModal({ className = '' }) {
  const { isOpen, onSelect } = useSelector((state) => state.gifModal);
  const classes = useStyles();
  const dispatch = useDispatch();
  const closeGifModal = useCallback(() => {
    dispatch(closeGifModalAction());
  }, [dispatch]);
  function onSelectWithClose(gifUrl) {
    onSelect(gifUrl);
    closeGifModal();
  }
  return (
    <Modal
      aria-labelledby="Add Post Modal"
      aria-describedby="This is a component used to add a post"
      open={isOpen}
      onClose={closeGifModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={classes.root}
    >
      <Fade in={isOpen}>
        {/* Gif modal is using material ui search field, which requires focus lock to work */}
        <FocusLock>
          <Container>
            <ModalContainer>
              <Gif onSelect={onSelectWithClose} toggleGifModal={closeGifModal} isOpen={isOpen} />
            </ModalContainer>
          </Container>
        </FocusLock>
      </Fade>
    </Modal>
  );
}

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  ${CenterFlexCSS};
  position: relative;
`;

const ModalContainer = styled.div`
  width: 50%;
  height: 90%;
  display: flex;
  ${CenterFlexCSS};
`;

const Header = styled.div`
  position: relative;
  // border-bottom: 1px solid ${(props) => props.theme.palette.divider};
  height: 3rem;
  display: flex;
  ${CenterFlexCSS};
`;

const BackContainer = styled.div`
  position: absolute;
  height: 3rem;
  padding: 0.5rem;
  left: 0rem;
  top: 0rem;
  display: flex;
  align-items: center;
`;
